import { type UseQueryResult, useQuery } from 'react-query';
import { OptionType } from '../../types/common';
import { InstanceSwitchService } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetSwitchSandboxListForProduction = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionType[] | undefined,
  unknown
> => {
  const getSwitchSandboxListForProduction = useQuery(
    ['getSwitchSandboxListForProduction'],
    async () => {
      return await handleRequest(InstanceSwitchService.getApiIdentityApiInstanceSandboxOptions());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          } as OptionType;
        });
      },
    }
  );

  return getSwitchSandboxListForProduction;
};

export default useGetSwitchSandboxListForProduction;
